

export const version = "V 14.0.25";
export const versionDate = "October 5, 2026";
export const versionNotes = "CFL NA counts, compact rows and team/header position breakdowns";

export const getScoutReports = async (playerID, user) => {
    const API_ENDPOINT = "https://www.fbxchange.com/ReactPHP/scoutreports.php"; // unchanged
    const res = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            scriptName: "getReports",
            ID: playerID,
            scout: user.scout,
            team: user.team || "",
        }),
    });
    const resp = await res.json();
    return resp;
};

export const getOneScoutReport = (reportID, user) => {
    return `scoutReport_${reportID}`;
}
